import { render, staticRenderFns } from "./FormCustomLocationField.vue?vue&type=template&id=54771c4e&"
import script from "./FormCustomLocationField.vue?vue&type=script&lang=js&"
export * from "./FormCustomLocationField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports